import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import {RouterModule, Routes} from '@angular/router';
import { CustomersComponent } from './customers/customers.component';
import {ChartsModule} from 'ng2-charts';
import { NgxPaginationModule } from 'ngx-pagination';
import { ProvidersComponent } from './providers/providers.component';
import { QuotesComponent } from './quotes/quotes.component';
import { ShippingComponent } from './shipping/shipping.component';
import { ObjectivesComponent } from './objectives/objectives.component';
import { MarketingComponent } from './marketing/marketing.component';
import { ReportsComponent } from './reports/reports.component';
import { ChatInboxComponent } from './chat-inbox/chat-inbox.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'chat', component: ChatInboxComponent },
  { path: 'home', component: HomeComponent },
  { path: 'customers', component: CustomersComponent },
  { path: 'providers', component: ProvidersComponent },
  { path: 'quotes', component: QuotesComponent },
  { path: 'shipping', component: ShippingComponent },
  { path: 'objectives', component: ObjectivesComponent },
  { path: 'marketing', component: MarketingComponent },
  { path: 'reports', component: ReportsComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomeComponent,
    CustomersComponent,
    ProvidersComponent,
    QuotesComponent,
    ShippingComponent,
    ObjectivesComponent,
    MarketingComponent,
    ReportsComponent,
    ChatInboxComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    ChartsModule,
    BrowserModule,
    NgxPaginationModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
